export enum MenuTabGroupLayout {
  LIST,
  CARD,
  SLIDING_CARD,
  FLAT_WITH_CALORIES,
  FLAT,
}
